import SpinnerIcon from '@icons/spinner.svg?react';
import type { LoaderProps } from './types';

function LoaderContent({ title, description }: Readonly<LoaderProps>) {
  return (
    <>
      <SpinnerIcon className="w-12 h-12 animate-spin" />
      {title && (
        // @TODO: Create custom variables for the 'font-weight' and 'color' of the 'title'.
        <h1 className="text-4xl leading-10 font-extrabold text-accent-foreground">{title}</h1>
      )}
      {description && <p className="text-muted-foreground">{description}</p>}
    </>
  );
}

export { LoaderContent };
